(function() {
  // =========================
  // Gallery Carousel Sync
  // =========================
  const gallery = document.querySelector('.product__gallery-carousel');
  const mainMediaContainer = document.querySelector('.main-media-container');

  if (gallery && mainMediaContainer) {
    const galleryItems = gallery.querySelectorAll('.gallery-item');
    const mainMediaItems = mainMediaContainer.querySelectorAll('.main-media-item');

    function switchMedia(index) {
      galleryItems.forEach((item, i) => {
        item.classList.toggle('active', i === index);
        // The thumbnails are <button>s (featured-product.liquid); tell assistive tech
        // which one is on show.
        item.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      mainMediaItems.forEach((item, i) => {
        if (i === index) {
          item.classList.add('active');
          item.style.display = 'block';
          const video = item.querySelector('video');
          if (video) {
            mainMediaItems.forEach(otherItem => {
              const otherVideo = otherItem.querySelector('video');
              if (otherVideo && otherVideo !== video) {
                otherVideo.pause();
                const playBtn = otherItem.querySelector('.video-play-pause');
                if (playBtn) {
                  playBtn.querySelector('.play-icon').style.display = 'block';
                  playBtn.querySelector('.pause-icon').style.display = 'none';
                }
              }
            });
          }
        } else {
          item.classList.remove('active');
          item.style.display = 'none';
        }
      });
    }

    galleryItems.forEach((item, index) => item.addEventListener('click', () => switchMedia(index)));
    switchMedia(0);
  }

  // =========================
  // Main Media Play/Pause
  // =========================
  document.querySelectorAll('.video-play-pause').forEach(button => {
    const videoWrapper = button.closest('.video-wrapper');
    const video = videoWrapper?.querySelector('video');
    const playIcon = button.querySelector('.play-icon');
    const pauseIcon = button.querySelector('.pause-icon');

    if (!video) return;

    video.muted = false;
    video.controls = false;

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        playIcon.style.display = 'none';
        pauseIcon.style.display = 'block';
      } else {
        video.pause();
        playIcon.style.display = 'block';
        pauseIcon.style.display = 'none';
      }
    });

    video.addEventListener('play', () => { playIcon.style.display = 'none'; pauseIcon.style.display = 'block'; });
    video.addEventListener('pause', () => { playIcon.style.display = 'block'; pauseIcon.style.display = 'none'; });
    video.addEventListener('ended', () => { playIcon.style.display = 'block'; pauseIcon.style.display = 'none'; });
  });

  // =========================
  // Video Carousel Controls
  // =========================
  const carouselVideoItems = document.querySelectorAll('.video-item');

  carouselVideoItems.forEach(item => {
    const video = item.querySelector('video.carousel-video');
    const playButton = item.querySelector('.carousel-video-play');
    const poster = item.querySelector('.video-poster');
    const playIcon = playButton.querySelector('.play-icon');
    const pauseIcon = playButton.querySelector('.pause-icon');

    function showPoster() {
      if (poster) poster.classList.add('active');
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
    }

    function hidePoster() {
      if (poster) poster.classList.remove('active');
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
    }

    // Initial state
    showPoster();

    // Click to toggle play/pause
    playButton.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      // Pause all other videos
      carouselVideoItems.forEach(otherItem => {
        if (otherItem !== item) {
          const otherVideo = otherItem.querySelector('video.carousel-video');
          const otherPoster = otherItem.querySelector('.video-poster');
          const otherButton = otherItem.querySelector('.carousel-video-play');
          if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
            if (otherPoster) otherPoster.classList.add('active');
            otherButton.querySelector('.play-icon').style.display = 'block';
            otherButton.querySelector('.pause-icon').style.display = 'none';
          }
        }
      });

      if (!video) return;

      if (video.paused) {
        video.play();
        hidePoster();
      } else {
        video.pause();
        showPoster();
      }
    });

    // Video events
    if (video) {
      video.addEventListener('play', hidePoster);
      video.addEventListener('pause', showPoster);
      video.addEventListener('ended', showPoster);

      // Hover: show pause icon while playing
      item.addEventListener('mouseenter', () => { if (!video.paused) pauseIcon.style.display = 'block'; });
      item.addEventListener('mouseleave', () => { if (!video.paused) pauseIcon.style.display = 'none'; });
    }
  });

  // =========================
  // Video Carousel - Mobile Swipe
  // =========================
  const videoCarousel = document.querySelector('.product__video-carousel');
  if (videoCarousel) {
    const wrapper = videoCarousel.querySelector('.video-carousel-wrapper');
    let startX = 0, scrollLeft = 0;

    wrapper.addEventListener('touchstart', e => {
      startX = e.touches[0].pageX;
      scrollLeft = wrapper.scrollLeft;
    }, { passive: true });

    // INP: handler only writes scrollLeft, never calls preventDefault, so passive
    // is safe. Lets the browser scroll-promote the touch.
    wrapper.addEventListener('touchmove', e => {
      const x = e.touches[0].pageX;
      wrapper.scrollLeft = scrollLeft + (startX - x) * 2;
    }, { passive: true });
  }

  // =========================
  // Rating Carousel
  // =========================
// =========================
// Rating Carousel
// =========================
const ratingCarousel = document.querySelector('.product__rating-carousel');
if (ratingCarousel) {
  const wrapper = ratingCarousel.querySelector('.rating-carousel-wrapper');
  const items = wrapper.querySelectorAll('.rating-item');
  const prev = ratingCarousel.querySelector('.rating-prev');
  const next = ratingCarousel.querySelector('.rating-next');
  const dotsContainer = ratingCarousel.querySelector('.rating-dots');
  let currentIndex = 0;

  // Only initialize if there are items
  if (items.length === 0) return;

  items.forEach((_, index) => {
    const dot = document.createElement('span');
    dot.classList.add('rating-dot');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
  });

  function updateCarousel() {
    // Calculate the full width including gap
    const containerWidth = wrapper.parentElement.offsetWidth;
    const translate = currentIndex * containerWidth;
    
    wrapper.style.transform = `translateX(-${translate}px)`;

    dotsContainer.querySelectorAll('.rating-dot').forEach((dot, i) => 
      dot.classList.toggle('active', i === currentIndex)
    );
    
    prev.style.opacity = currentIndex === 0 ? '0.5' : '1';
    prev.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
    next.style.opacity = currentIndex === items.length - 1 ? '0.5' : '1';
    next.style.pointerEvents = currentIndex === items.length - 1 ? 'none' : 'auto';
  }

  function goToSlide(index) {
    currentIndex = Math.max(0, Math.min(index, items.length - 1));
    updateCarousel();
  }

  prev.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });
  
  next.addEventListener('click', () => {
    if (currentIndex < items.length - 1) {
      currentIndex++;
      updateCarousel();
    }
  });

  // Touch support
  let startX = 0, currentX = 0, isDragging = false;
  
  // INP: rating-carousel touch handlers only read coordinates and toggle a
  // dragging flag — no preventDefault — so passive is safe. Lets the browser
  // scroll-promote independently.
  wrapper.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    isDragging = true;
  }, { passive: true });

  wrapper.addEventListener('touchmove', e => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
  }, { passive: true });

  wrapper.addEventListener('touchend', () => {
    if (!isDragging) return;
    const diff = startX - currentX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && currentIndex < items.length - 1) {
        currentIndex++;
      } else if (diff < 0 && currentIndex > 0) {
        currentIndex--;
      }
      updateCarousel();
    }
    isDragging = false;
  }, { passive: true });

  // Update on window resize
  window.addEventListener('resize', updateCarousel);
  
  updateCarousel();
}
  console.log('Full product video and rating carousel initialized.');

})();


document.addEventListener('DOMContentLoaded', function() {
  const child = document.querySelector('.product__video-carousel');
  const originalParent = child.parentNode; // store original parent
  const mobileParent = document.querySelector('.featured-product');

  function moveChild() {
    if (window.innerWidth <= 480) {
      if (mobileParent && child && child.parentNode !== mobileParent) {
        mobileParent.appendChild(child); // move to mobile parent
      }
    } else {
      if (originalParent && child && child.parentNode !== originalParent) {
        originalParent.appendChild(child); // move back to original
      }
    }
  }

  moveChild(); // run on page load
  window.addEventListener('resize', moveChild); // run on resize
});

// Accordion popup wiring lives in assets/product-accordion-popups.js (loaded
// alongside this file by featured-product.liquid; main-product.liquid loads
// it too on PDPs). The block that used to be here was a parallel copy of the
// same handlers, kept dead by the window.__productAccordionPopupBound guard.